import { render, staticRenderFns } from "./RecipeEditor.vue?vue&type=template&id=d9fc0ab4&scoped=true&"
import script from "./RecipeEditor.vue?vue&type=script&lang=js&"
export * from "./RecipeEditor.vue?vue&type=script&lang=js&"
import style0 from "./RecipeEditor.vue?vue&type=style&index=0&id=d9fc0ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fc0ab4",
  null
  
)

export default component.exports